/*
  Stable x Natural Sort
  https://github.com/Bill4Time/javascript-natural-sort/blob/master/naturalSort.js
  https://github.com/Two-Screen/stable/blob/master/stable.min.js
*/
/* eslint-disable */
function n(n,e){"function"!=typeof e&&(e=function(n,e){return String(n).localeCompare(e)});var t=n.length;if(1>=t)return n;for(var o=new Array(t),f=1;t>f;f*=2){r(n,e,f,o);var i=n;n=o,o=i}return n}var e=function(e,r){return n(e.slice(),r)};e.inplace=function(e,t){var o=n(e,t);return o!==e&&r(o,null,e.length,e),e};var r=function(n,e,r,t){var o,f,i,u,l,a=n.length,c=0,v=2*r;for(o=0;a>o;o+=v)for(f=o+r,i=f+r,f>a&&(f=a),i>a&&(i=a),u=o,l=f;;)if(f>u&&i>l)t[c++]=e(n[u],n[l])<=0?n[u++]:n[l++];else if(f>u)t[c++]=n[u++];else{if(!(i>l))break;t[c++]=n[l++]}};
export default e
